





























import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class TransferItemList extends Vue {
    @Prop(Function) private loader!: (offset: number, pageSize: number) => Promise<TransferItemData[]>
    @Prop({ type: Number, default: 10 }) private pageSize!: number
    @Prop(String) private sym!: string

    private items = null as TransferItemData[] | null
    private error = null as Error | null
    private loading = false
    private offset = 0
    get canNext() { return this.items && this.items.length === this.pageSize }
    get canPrev() { return this.items && this.offset > 0 }
    get range() {
        if (!this.loading && this.items && this.items.length > 0) {
            return [this.offset, this.offset + this.items.length]
        }
        return null
    }

    private nextPage() {
        this.offset += this.pageSize
        this.reload()
    }
    private prevPage() {
        if (this.offset >= this.pageSize) {
            this.offset -= this.pageSize
            this.reload()
        }
    }
    private async reload() {
        if (this.loading) {
            return
        }
        this.error = null
        this.loading = true
        this.items = null
        try {
            this.items = await this.loader(this.offset, this.pageSize)
        } catch (err) {
            this.error = err
        } finally {
            this.loading = false
        }
    }
    private created() {
        this.reload()
    }
}
